import { uniqueId } from 'lodash'

export default function FictivSymbol<T extends string>(
    name: T,
): `${T}-${string}` {
    return `${name}-${uniqueId()}`
}
